import React from 'react';
import './pagemenu.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { logNavigation } from '../utils/diagnosticLogger';

const PageMenu = ({ className, onNavigate }) => {
    let navigate = useNavigate();
    const location = useLocation();

    function goToRetail() {
        logNavigation(location.pathname, '/', 'menu-click-retail');
        navigate('/');
        if (onNavigate) onNavigate();
      }
    
      function goToJobs() {
        logNavigation(location.pathname, '/jobs', 'menu-click-jobs');
        navigate('/jobs');
        if (onNavigate) onNavigate();
      }

      function goToAccounts() {
        logNavigation(location.pathname, '/accounts', 'menu-click-accounts');
        navigate('/accounts');
        if (onNavigate) onNavigate();
      }

  return (
    <div className={`pagemenu ${className || ''}`} >

        <button
          className={`headerbutton ${location.pathname === '/' ? 'active' : ''}`}
          onClick={goToRetail}
        >
          Retail
        </button>

        <button
          className={`headerbutton ${location.pathname === '/jobs' ? 'active' : ''}`}
          onClick={goToJobs}
        >
          Jobs
        </button>

        <button
          className={`headerbutton ${location.pathname === '/accounts' ? 'active' : ''}`}
          onClick={goToAccounts}
        >
          Accounts
        </button>
    </div>
  );
};

export default PageMenu;